import { observable } from 'mobx';

import { Model, ModelRegistry } from 'core/index';

export class PermissionedModel extends Model {
  static registryName = 'PermissionedModel';
  @observable canUpdate = false;
  @observable canDelete = false;
}
ModelRegistry.add(PermissionedModel);
